import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { useStore } from '@feathr/extender/state';

import { skeleton } from '@feathr/components/dist/style/skeleton.css';

interface IProps {
  className?: string;
  id: string;
}

function FormLabel({ className, id }: Readonly<IProps>): JSX.Element {
  const { Forms } = useStore();
  const form = Forms.get(id);
  return <div className={classNames({ [skeleton]: form.isPending }, className)}>{form.name}</div>;
}

export default observer(FormLabel);
